/**
 * Notifications queries — push subscription persistence for the
 * `usePushNotifications` hook. Lives outside `admin/` because the call
 * is user-scoped (any logged-in user enabling daily push), not admin-only.
 */
import { supabase } from '@/lib/supabase'

/** Save a push notification subscription. Upserts on (user_id, endpoint)
 *  so a re-subscribe from the same device replaces the previous row
 *  rather than accumulating duplicates. */
export async function savePushSubscription(userId, subscription) {
  const { error } = await supabase
    .from('push_subscriptions')
    .upsert({ user_id: userId, ...subscription }, { onConflict: 'user_id, endpoint' })
  if (error) throw error
}
